var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSharedPaymentFlexibility(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m271 195v182c0 8.398438-6.597656 15-15 15s-15-6.601562-15-15v-182c0-8.402344 6.597656-15 15-15s15 6.597656 15 15zm0 0",
    fill: "#a8ebfa"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m271 195v182c0 8.398438-6.597656 15-15 15v-212c8.402344 0 15 6.597656 15 15zm0 0",
    fill: "#76e2f8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m452 287v60c0 8.398438-6.597656 15-15 15s-15-6.601562-15-15v-45h-332v45c0 8.398438-6.597656 15-15 15s-15-6.601562-15-15v-60c0-8.402344 6.597656-15 15-15h362c8.402344 0 15 6.597656 15 15zm0 0",
    fill: "#a8ebfa"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m452 287v60c0 8.398438-6.597656 15-15 15s-15-6.601562-15-15v-45h-166v-30h181c8.402344 0 15 6.597656 15 15zm0 0",
    fill: "#76e2f8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m75 482c-41.351562 0-75-33.648438-75-75s33.648438-75 75-75 75 33.648438 75 75-33.648438 75-75 75zm0 0",
    fill: "#25d9f8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m256 362c-41.398438 0-75 33.601562-75 75s33.601562 75 75 75 75-33.601562 75-75-33.601562-75-75-75zm0 0",
    fill: "#25d9f8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m437 482c-41.351562 0-75-33.648438-75-75s33.648438-75 75-75 75 33.648438 75 75-33.648438 75-75 75zm0 0",
    fill: "#00c0f1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m256 0c-57.898438 0-105 47.101562-105 105s47.101562 105 105 105 105-47.101562 105-105-47.101562-105-105-105zm0 0",
    fill: "#fdbf00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m361 105c0 57.898438-47.101562 105-105 105v-210c57.898438 0 105 47.101562 105 105zm0 0",
    fill: "#ff9f00"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m256 60c-24.902344 0-45 20.097656-45 45 0 24.898438 20.097656 45 45 45s45-20.101562 45-45c0-24.902344-20.097656-45-45-45zm0 0",
    fill: "#ffd400"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m301 105c0 24.898438-20.097656 45-45 45v-90c24.902344 0 45 20.097656 45 45zm0 0",
    fill: "#fdbf00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m331 437c0 41.398438-33.601562 75-75 75v-150c41.398438 0 75 33.601562 75 75zm0 0",
    fill: "#00c0f1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharedPaymentFlexibility);
export default __webpack_public_path__ + "static/media/shared-payment-flexibility.9d39651ef095f0bfd5cead00ad74d2fe.svg";
export { ForwardRef as ReactComponent };